// extracted by css-extract-rspack-plugin
export default {"Box":"roadmap-table-layout-module__Box__ZIl3X1q","Box_1":"roadmap-table-layout-module__Box_1__cH4OFJK"};